<mat-dialog-content class="modal-header"><h2 mat-dialog-title>REGISTRO DE ACCIDENTABILIDAD</h2></mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)"  appIdentityRevealed>
  
    <mat-dialog-content class="modal-body">
      <div class="content">
        <div class="form-horizontal"> 
          
          <div class="form-group">
            <label class="col-md-2 control-label">GBU (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>
                    Seleccione
                  </mat-label>
                  <mat-select matSelect [(ngModel)]="data.idGbuSelected" name="idGbuSelected" #idGbuSelected="ngModel" *ngIf="data.editable" required>
                    <mat-option
                      *ngFor="let item of listaGbus; index as i"
                      [value]="item.idGbu"
                      >{{ item.nombre }}</mat-option>
                  </mat-select>
                  <input matInput *ngIf="!data.editable" type="text" name="gbu" [(ngModel)]="data.gbu" disabled/>
                </mat-form-field>             
            </div>   
            <label class="col-md-2 control-label">Proyecto:</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                  <mat-label>
                    Proyecto
                  </mat-label>
                  <mat-select matSelect
                  [(ngModel)]="data.idProyecto"
                  name="idProyecto"
                  #idProyecto="ngModel" *ngIf="data.editable" >
                    <mat-option
                      *ngFor="let item of listaProyectos; index as i"
                      [value]="item.idProyecto"
                      >{{ item.nombre }}</mat-option>
                  </mat-select> 
                  <input matInput *ngIf="!data.editable" type="text" name="proyecto" [(ngModel)]="data.proyecto" disabled/>
                </mat-form-field>             
            </div>            
        </div>
        <div class="form-group">  
          <label class="col-md-2 control-label">Fecha Evento (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Fecha Evento</mat-label>
              <input
                      matInput
                      [matDatepicker]="pckrFechaEvento"
                      [(ngModel)]="data.fechaEvento"
                      id="fechaEvento"
                      name="fechaEvento"
                      [disabled]="!data.editable"
                      required 
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrFechaEvento"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaEvento></mat-datepicker>
              </mat-form-field>             
          </div>  
          <label class="col-md-2 control-label">Tipo Empleado (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>
                  Seleccione
                </mat-label>
                <mat-select matSelect
                [(ngModel)]="data.idTipoEmpleadoSelected"
                name="idTipoEmpleadoSelected" *ngIf="data.editable"
                #idTipoEmpleadoSelected="ngModel" required>
                  <mat-option
                          *ngFor="let item of listaTipoEmpleado; index as i"
                          [value]="item.idTipoEmpleado"
                          >{{ item.nombre }}</mat-option>
                </mat-select>
                <input matInput *ngIf="!data.editable" type="text" name="tipoEmpleado" [(ngModel)]="data.tipoEmpleado" disabled/>
              </mat-form-field>             
          </div>           
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Categoría (*):</label>
        <div class="col-md-10">
          <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="data.idCategoriaHipoSelected" name="idCategoriaHipoSelected" #idCategoriaHipoSelected="ngModel" *ngIf="data.editable"  required>
                <mat-option
                    *ngFor="let item of listaCategorias; index as i"
                    [value]="item.idCategoriaHipo"
                    >{{ item.nombre }}</mat-option>
              </mat-select>
              <input matInput *ngIf="!data.editable" type="text" name="categoriaHipo" [(ngModel)]="data.categoriaHipo" disabled/>
            </mat-form-field>             
        </div>            
    </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Texto Identificativo (*):</label>
        <div class="col-md-10">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Texto Identificativo</mat-label>
            <input matInput type="text" placeholder="Texto Identificativo" maxlength="250"
              name="TextoIdentificativo" [(ngModel)]="data.textoIdentificativo" [disabled]="!data.editable" required
            >
            </mat-form-field>             
        </div>               
    </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Descripción:</label>
          <div class="col-md-10">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Motivo"
                rows="5"
                [(ngModel)]="data.descripcion"                      
                name="comentarios" maxlength="2000" [disabled]="!data.editable"
              ></textarea>
              <!-- 
                [disabled]="modelPersona.idEstado === 2" -->
            </mat-form-field>
          </div>
        </div> 
        <div class="form-group">
          <label class="col-md-2 control-label">Cliente:</label>
          <div class="col-md-10">
            <mat-form-field appearance="outline">
              <mat-label>Cliente</mat-label>
              <input matInput type="text" placeholder="Cliente" maxlength="250"
                name="Cliente"
                [(ngModel)]="data.cliente" [disabled]="!data.editable"  
              >
              </mat-form-field>             
          </div>            
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Regla Incumplida (*):</label>
        <div class="col-md-10">
          <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect
              [(ngModel)]="data.idTipoReglaSelected"
              name="idTipoReglaSelected"
              #idTipoReglaSelected="ngModel" *ngIf="data.editable" required>
                <mat-option
                    *ngFor="let item of listaTipoRegla; index as i"
                    [value]="item.idTipoRegla"
                    >{{ item.nombre }}</mat-option>
              </mat-select>
              <input matInput *ngIf="!data.editable" type="text" name="tipoRegla" [(ngModel)]="data.tipoRegla" disabled/>
            </mat-form-field>             
        </div>            
    </div>
      <div class="form-group">  
          <label class="col-md-2 control-label">Tiempo Perdido (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>
                  Seleccione
                </mat-label>
                <mat-select matSelect
                [(ngModel)]="data.tiempoPerdidoSelected" 
                name="tiempoPerdidoSelected"
                #tiempoPerdidoSelected="ngModel" *ngIf="data.editable" required>
                <mat-option
                      *ngFor="let item of optionsSINO; index as i"
                      [value]="item.id"
                      >{{ item.nombre }}</mat-option>
                </mat-select>
                <input matInput *ngIf="!data.editable" type="text" name="tiempoPerdido" [(ngModel)]="data.tiempoPerdido" disabled/>
              </mat-form-field>             
          </div>  
        <label class="col-md-2 control-label" *ngIf="data.tiempoPerdidoSelected == 1"># Días:</label>
        <div class="col-md-2" *ngIf="data.tiempoPerdidoSelected == 1">
          <mat-form-field appearance="outline">
            <mat-label>Días</mat-label>
            <input matInput type="text" placeholder="# Días Perdidos" maxlength="4"
              name="nroDiasPerdidos" [(ngModel)]="data.nroDiasPerdidos" [disabled]="!data.editable" appTwoDigitDecimaNumber
            >
            </mat-form-field>             
        </div>           
    </div>
    <div class="form-group"> 
      <label class="col-md-2 control-label">Tipo Accidente (*):</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect
            [(ngModel)]="data.idTipoAccidenteSelected"
            name="idTipoAccidenteSelected"
            #idTipoAccidenteSelected="ngModel" *ngIf="data.editable" required>
              <mat-option
                      *ngFor="let item of listaTipoAccidente; index as i"
                      [value]="item.idTipoAccidente"
                      >{{ item.nombre }}</mat-option>
            </mat-select>
            <input matInput *ngIf="!data.editable" type="text" name="tipoAccidente" [(ngModel)]="data.tipoAccidente" disabled/>
          </mat-form-field>             
      </div>             
  </div>
        </div>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end" class="modal-actions">
      <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-button ><mat-icon>save</mat-icon> Guardar</button> 
      <!-- [disabled]="!EsValido()" -->
      <!-- [mat-dialog-close]="data" -->
      <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" [disabled]="modelForm.invalid" (click)="guardar()">Submit</button> -->
      <button type="button" class="btn btn-naranja2" (click)="onNoClick()" mat-button ><mat-icon>exit_to_app</mat-icon> Salir</button>
    </mat-dialog-actions>
    
    </form>